exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td.day {\r\n\tcursor: pointer;\r\n}\r\n\r\nth.prev {\r\n\tcursor: pointer;\r\n}\r\n\r\nth.next {\r\n\tcursor: pointer;\r\n}\r\n\r\nth.datepicker-switch {\r\n\tcursor: pointer;\r\n}\r\n\r\ntd span.month {\r\n\tcursor: pointer;\r\n\tpadding: 0 4px;\r\n}\r\n", ""]);

// exports
